import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import NewsUpload from "../../components/pageManager/NewsUpload";
import EditNewsForm from "../../components/pageManager/EditNewsForm";

const NewsEditPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <EditNewsForm />
                </div>
            </div>
        </div>
    );
};

export default NewsEditPage;
